<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex justify-content-between catalogo-text"
          >
            Catálogo de almacenes
            <router-link :to="{ name: 'NuevoAlmacen' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Almacén
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.almacenes"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por almacenes..."
                />
              </template>
              <template #ubicacion="{item}">
                <td class="py-2">
                  {{ getUbicacion(item.payload.ubicacion_id) }}
                </td>
              </template>
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarAlmacen', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Cultivo"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el almacén {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Almacén</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteAlmacen(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "ubicacion", label: "Ubicación", _style: "width:40%" },
  { key: "nombre", label: "Nombre", _style: "width:40%" },

  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Almacenes",

  data() {
    return {
      ubicaciones: [],
      almacenes: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.updateAllInfo();
    // this.isLoading = true;
    // const alm = [
    //   this.$store.dispatch("customHTTP", { schema: "ubicaciones" }),
    //   this.$store.dispatch("customHTTP", {
    //     schema: "almacenes",
    //     limit: 50,
    //     page: 1,
    //     filter: {
    //       wherein: [
    //         {
    //           field: "payload->ubicacion_id",
    //           value: [this.ubicacionRaiz]
    //         }
    //       ]
    //     },
    //     ["with-storage"]: ["*"]
    //   })
    // ];
    // // this.$store
    // //   .dispatch("customHTTP", { schema: "ubicaciones" })
    // Promise.all(alm)
    //   .then(([ubicaciones, almacenes]) => {
    //     this.ubicaciones = ubicaciones.data;
    //     this.almacenes = almacenes.data;
    //     this.pages = almacenes.paginate.last_page;
    //     this.page = almacenes.paginate.current_page;
    //   })
    //   .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.almacenes.filter(
        i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase()) ||
          this.getUbicacion(i.payload.ubicacion_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateAllInfo();
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          limit: 50,
          page: 1,
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaiz]
              }
            ],
            where: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.almacenes = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          limit: 50,
          page: event,
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaiz]
              }
            ],
            orwhere: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${this.filter.toUpperCase()}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          },
          ["with-storage"]: ["*"]
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    getUbicacion(ubicacion_id) {
      const ubicacionActual = this.ubicaciones.filter(
        ubicacion => ubicacion.id == ubicacion_id
      );
      if (ubicacionActual.length > 0) {
        return ubicacionActual[0].payload.nombre;
      }
      return "";
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteAlmacen(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "almacenes",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.almacenes.splice(index, 1);
          }
          this.cancelModal = false;
        });
    },
    updateAllInfo() {
      this.isLoading = true;
      const alm = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }),
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          limit: 50,
          page: 1,
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaiz]
              }
            ]
          },
          ["with-storage"]: ["*"]
        })
      ];
      // this.$store
      //   .dispatch("customHTTP", { schema: "ubicaciones" })
      Promise.all(alm)
        .then(([ubicaciones, almacenes]) => {
          this.ubicaciones = ubicaciones.data;
          this.almacenes = almacenes.data;
          this.pages = almacenes.paginate.last_page;
          this.page = almacenes.paginate.current_page;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
</style>
